import { api } from "~/shared/api"

export function markAllAsRead() {
	return api.post("noty/integration/setReadStatusUserNotification")
}
